import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { BUTTON_TYPES } from '@savgroup-front-common/constants';
import { Heading, Panel } from '@savgroup-front-common/core';
import { Button } from '@savgroup-front-common/core/src/atoms/button';

const $LinkRow = styled.div`
  margin-top: 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const $Description = styled.p`
  margin: 0.75rem 0 0;
  color: ${({ theme }) => theme.newUI.variationColors?.dark2 || '#666'};
  font-size: 0.9rem;
  line-height: 1.5;
`;

const SUBMIT_RULE_ROUTE = '/administration/console-regles/publication';

const ConsoleReglesPage = () => {
  return (
    <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
      <Heading level={1}>Console de paramétrage — Règles</Heading>
      <div style={{ marginTop: '2rem' }}>
        <Panel>
          <Heading level={2}>Règles métier</Heading>
          <$Description>
            Prototype inspiré de la console Control : liste des règles modifiées en brouillon,
            puis publication via un récapitulatif par catégorie (acteurs, solutions, garanties…).
          </$Description>
          <$LinkRow>
            <Link to={SUBMIT_RULE_ROUTE} style={{ textDecoration: 'none', display: 'inline-block' }}>
              <Button primary type={BUTTON_TYPES.BUTTON} data-testid="go-to-submit-rule">
                Publier les règles modifiées
              </Button>
            </Link>
          </$LinkRow>
        </Panel>
      </div>
    </div>
  );
};

export default ConsoleReglesPage;
